import React, { useContext, useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { AuthContext } from "../../../context/Authcontext";
import axios from "axios";
import toast from "react-hot-toast";
const base_url = process.env.REACT_APP_API_URL;
const AdminMatches = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [permit, setPermit] = useState([]);
  const { getRoles } = useContext(AuthContext);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false); // ✅ Loading state
  const [activeTab, setActiveTab] = useState("myMatches");
  const [activeTab1, setActiveTab1] = useState("Cricket");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // console.log("Active tab is ", activeTab)
  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  const fetchRoles = async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");

    try {
      const roles = await getRoles(auth, role);

      roles.map((role) => {
        const values = Object.values(role);

        values[0].map((val) => {
          if (Object.keys(val).includes("matches")) {
            const permit = Object.values(val);

            setPermit(permit[0]);
          }
        });
      });
    } catch (error) {
      console.log("ert", error);
    }
  };

  const GetAllMatches = async (Type) => {
    // console.log("Fetching matches...");
    // console.log("Type is", Type);
    setLoading(true); // ✅ Start loading before fetching data

    try {
      const auth = localStorage.getItem("admin");

      const response = await axios.get(
        `${base_url}/api/webapi/admin/getAllMatch`,
        {
          params: { Type }, // ✅ Pass Type as a query parameter
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      const data = response?.data.data;
      setMatches(data || []);
      // console.log("Matches received:", data);
    } catch (error) {
      console.error("Error fetching matches:", error);
    } finally {
      setLoading(false); // ✅ Stop loading after API response (success or error)
    }
  };


  const GetMyMatches = async (Type)=>{

    // console.log("Fetching matches...");
    // console.log("Type is", Type);
    setLoading(true); // ✅ Start loading before fetching data

    try {
      const auth = localStorage.getItem("admin");

      const response = await axios.get(
        `${base_url}/api/webapi/admin/getMyMatch`,
        {
          params: { Type }, // ✅ Pass Type as a query parameter
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      const data = response?.data.data;
      setMatches(data || []);
      console.log("Matches received:", data);
    } catch (error) {
      console.error("Error fetching matches:", error);
    } finally {
      setLoading(false); // ✅ Stop loading after API response (success or error)
    }
  }


  const AddMatch = async (MatchId) => {
  
    try {
      const auth = localStorage.getItem("admin");

      const response = await axios.post(
        `${base_url}/api/webapi/admin/addMatch?MatchId=${MatchId}`, // ✅ Pass MatchId as a query param
        {}, // Empty body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
        // console.log("response.data.success", response.data.message)
      if (response.data.success) {
        // console.log("Match successfully added:", response.data.message);
        toast.success(response.data.message ); // ✅ Show success message
      } else {
        // console.error("Failed to add match:",);
        toast.error( response.data.message);
      }

    } catch (error) {
      console.error("Error adding match:", error);
      toast.error("Error Adding Message");
    }
  };

  const handleAll= async()=> {
    try{
      const auth= localStorage.getItem('admin');
      const alleventIds= matches.map((match) => match.eventid);
      const selectionid= matches.map((match)=> match.selectionid);
      // console.log(alleventIds);

      const response= await axios.post(base_url + '/api/webapi/admin/addAllMatch',
        {alleventIds, selectionid},
        {
          headers:{
            'content-type':'application/json',
            Authorization:`${auth}`,
          }
        }
      );

      // console.log(response);

      if(response?.data.success){
        toast.success(response?.data.message);
      }else{
        toast.error(response?.data.message);
      }

    }catch(err){
      console.log(err);
    }
  };


  useEffect(() => {
    fetchRoles();
    GetMyMatches("Cricket");
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
    <div className="wrapper">
      {/* Main Sidebar */}
      <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div className="container-fluid">
          <h5 className="m-0">Add Matches</h5>
        </div>
        <section className="content">
         
          {activeTab === "myMatches" && (
        <div id="myMatches" className="mt-2 tophead d-flex justify-content-between">
          <div className="d-flex align-items-center cursor-pointer">
            <div className={`p-2 mid ${activeTab1 === "Cricket" ? "bg-dark text-white" : ""}`} style={{ cursor: "pointer" }} onClick={() => {GetMyMatches("Cricket");; setActiveTab1("Cricket")}}>
              <img src="/assets/images/crickball1.png" height="20px" width="20px" alt="Cricket Ball" />
              Cricket
            </div>

            <div className={`p-2 mid ${activeTab1 === "Tennis" ? "bg-dark text-white" : ""}`} style={{ cursor: "pointer" }} onClick={() => {GetMyMatches("Tennis"); setActiveTab1("Tennis")}}>
              <img src="/assets/images/tennis1.png" height="20px" width="20px" alt="Tennis Ball" />
              Tennis
            </div>

            <div className={`p-2 mid ${activeTab1 === "Soccer" ? "bg-dark text-white" : ""}`} style={{ cursor: "pointer" }} onClick={() =>{ GetMyMatches("Soccer"); setActiveTab1("Soccer")}}>
              <img src="/assets/images/soccer1.png" height="19px" width="19px" alt="Soccer Ball" />
              Soccer
            </div>
          </div>
          <div className="d-flex gap-2 pb-1">
              {activeTab !== "myMatches" && (<button
                type="button"
                className={`btn btn-sm btn-primary px-3 py-1`}
                onClick={handleAll}
              >
                Add All
              </button>)}
              <button
                type="button"
                className="btn btn-sm btn-primary refreshButton px-3 py-1"
              >
                Refresh
              </button>
            </div>
        </div>
      )}

      {/* Upcoming Matches Section */}
      {activeTab === "upcomingMatches" && (
        <div id="upcomingMatches" className="mt-2 tophead d-flex justify-content-between">
          <div className="d-flex align-items-center cursor-pointer">
            <div className={`p-2 mid ${activeTab1 === "Cricket" ? "bg-dark text-white" : ""}`} style={{ cursor: "pointer" }} onClick={() => {GetAllMatches("Cricket"); setActiveTab1("Cricket")}}>
              <img src="/assets/images/crickball1.png" height="20px" width="20px" alt="Cricket Ball" />
              Cricket
            </div>

            <div className={`p-2 mid ${activeTab1 === "Tennis" ? "bg-dark text-white" : ""}`} style={{ cursor: "pointer" }} onClick={() =>{ GetAllMatches("Tennis"); setActiveTab1("Tennis")}}>
              <img src="/assets/images/tennis1.png" height="20px" width="20px" alt="Tennis Ball" />
              Tennis
            </div>

            <div className={`p-2 mid ${activeTab1 === "Soccer" ? "bg-dark text-white" : ""}`} style={{ cursor: "pointer" }} onClick={() => {GetAllMatches("Soccer"); setActiveTab1("Soccer")}}>
              <img src="/assets/images/soccer1.png" height="19px" width="19px" alt="Soccer Ball" />
              Soccer
            </div>
          </div>
          <div className="d-flex gap-2 pb-1">
              {activeTab !== "myMatches" && (<button
                type="button"
                className={`btn btn-sm btn-primary px-3 py-1`}
                onClick={handleAll}
              >
                Add All
              </button>)}
              <button
                type="button"
                className="btn btn-sm btn-primary refreshButton px-3 py-1"
              >
                Refresh
              </button>
            </div>
        </div>
      )}


<div className="mt-2 tophead d-flex justify-content-between">
  <div className="d-flex align-items-center cursor-pointer">
    
    {/* My Matches */}
    <div
      className={`p-2 mid ${activeTab === "myMatches" ? "bg-dark text-white" : ""}`}
      style={{ cursor: "pointer" }}
      onClick={() => {
        setActiveTab("myMatches");
        GetMyMatches("Cricket");  // ✅ Calls GetMyMatches when clicked
      }}
    >
      My Matches
    </div>

    {/* Upcoming Matches */}
    <div
      className={`p-2 mid ${activeTab === "upcomingMatches" ? "bg-dark text-white" : ""}`}
      style={{ cursor: "pointer" }}
      onClick={() => {
        setActiveTab("upcomingMatches");
        GetAllMatches("Cricket");  // ✅ Calls GetAllMatches when clicked
      }}
    >
      Upcoming Matches
    </div>

  </div>
    </div>

          <div className="table-responsive">
            <table
              role="grid"
              className="table table-hover datatable table-striped mt-4"
            >
              <thead className="bg-dark text-light">
                <tr>
                  <th>Sport Name</th>
                  {/* <th>Event Name</th> */}
                  <th>Competition Name</th>
                  <th>Market Name</th>
                  {/* <th>Selection ID</th>
                  <th>Runner Name</th> */}
                  <th>Open Date</th>
                  {activeTab !== "myMatches" && <th>Action</th>}

                </tr>
              </thead>
              <tbody>
                {matches.length > 0 ? (
                  matches.map((match, index) => (
                    <tr key={index}>
                      <td>
                        <div>{match.sportname}</div>
                        <div className="text-bold">{match.eventname}</div>
                      </td>
                      {/* <td>
                  <div className="text-bold">{match.marketname}</div>
                  <div>{new Date(match.opendate).toLocaleString()}</div>
                </td> */}
                      <td>{match.competitionname}</td>
                      <td>{match.marketname}</td>
                      {/* <td>{match.selectionid}</td>
                      <td>{match.runnername}</td> */}
                      <td>{new Date(match.opendate).toISOString().replace("T", " ").replace("Z", "")}</td>
                      {activeTab !== "myMatches" && (
                    <td className="btn btn-primary btn-sm ms-2" onClick={() => AddMatch(match.eventid)}>
                      Add
                    </td>
                  )}

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No matches available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </div>
      <a
        id="back-to-tops"
        href="##"
        className="btn btn-primary back-to-top"
        role="button"
        aria-label="Scroll to top"
      >
        <i className="fas fa-chevron-up" />
      </a>
    </div>
    </>
  );
};



export default AdminMatches;